import z from 'zod';

export const contactTypeEnum = z.enum(['phone', 'email']);

export const newContactStateSchema = z.object({
  type: contactTypeEnum,
});
export type NewContactState = z.infer<typeof newContactStateSchema>;

export const codeInputStateSchema = z.object({
  type: contactTypeEnum,
  contact: z.string().min(1),
});
export type CodeInputState = z.infer<typeof codeInputStateSchema>;
